import React, { useContext } from 'react';
import { AuthContext } from '../context/Auth';
import DataLoader from '../component/DataLoader';
import { useNavigate } from 'react-router-dom';
import { BsArrowUp } from "react-icons/bs";

const NotFound = () => {
  const { loadingModule, setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  // Image URL dynamically loaded
  const errorImage = "https://static.vecteezy.com/system/resources/thumbnails/024/217/744/small/design-template-for-web-page-with-404-error-isometric-page-not-working-error-png.png";
  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("email");
    localStorage.removeItem("timeLeft");
    localStorage.removeItem("User_info");
    navigate("/login");
  };
  return (
    <div className="min-h-screen mt-8 flex flex-col items-center justify-center px-6">
      <div className="text-center max-w-lg">
        {loadingModule ? (
          <DataLoader message="Loading modules..." size={50} color="green" animationSpeed="1s" />
        ) : (
          <>
            {/* Error Image */}
            <img
              src={errorImage}
              alt="Module Not Found"
              className="mx-auto w-3/4 max-w-sm mb-6"
            />

            {/* Message */}
            <h1 className="text-2xl font-semibold text-gray-800 mb-4">
              Module Not Available
            </h1>
            <p className="text-lg text-gray-600 mb-4">
              Oops! The module you’re looking for is not found or currently unavailable.
            </p>
            <button onClick={logout} className="text-lg text-blue-600 mb-4">
              Please <strong className="text-red-600 underline">log out</strong> and log in again.
            </button>
            <p className="text-lg text-green-600">
              If the issue persists, contact the <strong className="text-green-800">Business Analyst (BA) Team</strong> for assistance.
            </p>
            <BsArrowUp onClick={() => navigate(-1)} size={20} className='-rotate-90 p-1 rounded-full fixed bg-black text-white cursor-pointer' />
          </>
        )}
      </div>
    </div>
  );
};

export default NotFound;
